import rawPointLapsSource from "./makePointLaps.ts?raw";
import rawTestSource from "./makePointLaps.test.ts?raw";

import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDarkReasonable } from "react-syntax-highlighter/dist/esm/styles/hljs";

export const PointLapSourceCode = () => (
  <div
    style={{
      backgroundColor: "#282c34",
      width: "100%",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "600px",
        height: "100%",
        overflowY: "scroll",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <SyntaxHighlighter
        children={rawPointLapsSource}
        language="javascript"
        style={atomOneDarkReasonable}
        customStyle={{
          fontSize: "12px",
          lineHeight: "1.2",
        }}
        codeTagProps={{
          style: {
            fontSize: "inherit",
            lineHeight: "inherit",
          },
        }}
      />
      <SyntaxHighlighter
        children={rawTestSource}
        language="javascript"
        style={atomOneDarkReasonable}
        customStyle={{
          fontSize: "12px",
          lineHeight: "1.2",
        }}
        codeTagProps={{
          style: {
            fontSize: "inherit",
            lineHeight: "inherit",
          },
        }}
      />
    </div>
  </div>
);
